import { api } from "@/api";

export default class API {
  static getMyInfo() {
    return api.get(`/v1/me/`);
  }

  static putMyInfo(payload) {
    return api.put(`v1/me/`, payload);
  }

  static putChangePassword(payload) {
    return api.put(`v1/me/alterar-senha/`, payload);
  }

  static postAvatar(payload) {
    return api.post(`/arquivos/upload/`, payload);
  }
}
